import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Col,
  Row,
  Radio,
  Input,
  Checkbox,
  Form,
  Button,
  InputNumber,
  message,
} from "antd";
import DATA from "./questionform";
// import { getStyleProperties } from "../../../utils/CustomFunc";
// import axios from "../../utils/BasicAuthAPI";
import "./storm.css";
import queryString from "query-string";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import liracrypt from "../Liracrypt/liracrypt";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import SessionError from "../ApiErrorComp/SessionError";
import { getStyleProperties } from "../../utils/CustomFunc";
import FormElement from "./FormElement";
import ButtonPicker from "../ReportFormGenerator/Button/Button";
import AdvanceButton from "../ReportFormGenerator/AdvanceButton/AdvanceButton";
import moment from "moment";
import TextBox from "../ReportFormGenerator/TextBox/TextBox";
import HModal from "../../pages/HModal";
import { useSelector } from "react-redux";


const OpObservShStorm = (props) => {
  const { docNo } = useParams();
  const urlCode = useSelector(state => state.urlCode);
  let history = useHistory();
  let location = useLocation();
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [isHModalVisible, setIsHModalVisible] = useState(false);
  const [action, setAction] = useState({});
  const params = queryString.parse(location.search);
  const [stormResponse, setStormResponse] = useState(null);
  const [examDetail, setExamDetail] = useState(null);
  const [loginError, setLoginError] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);
  const { TextArea } = Input;

  props.setPageHeader("");
  const [form] = Form.useForm();
  const [advanceBtnIndex, setAdvanceBtnIndex] = useState(0);

  const fetchAPI = () => {
    liracrypt
      .get("/qc/auditrecord", { sessid: docNo })
      .then(({ data }) => {
        setStormResponse(data);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    fetchAPI();
    // setStormResponse(DATA);
  }, []);


  const onResponse = ({ data }) => {
    // setStormResponse(data);
    message.success(
      stormResponse?.config?.buttons[advanceBtnIndex].msg
        ? stormResponse?.config?.buttons[advanceBtnIndex].msg
        : "Submitted Successfully"
    );
    let btnData = stormResponse?.config?.buttons[advanceBtnIndex];
    if (btnData.action === "clearForm") {
      form.resetFields();
      
    }
    if (btnData.action === "blankPage") {
      setStormResponse(null);
    };
    if (btnData.action === "reloadStorm") {
      setStormResponse(null);
      fetchAPI();
    }
    if (btnData.action === "newTab") {
      window.open(`/v02/${urlCode}` + btnData.route, '_blank');
    };

    if (btnData.action === 'refreshStorm') {
      setIsHModalVisible(true);
      setAction({ edit: btnData.popUpModal });
    }
  };

  const onResponseError = (error) => {
    console.log("Error****:");
    if (error.response !== undefined) {
      if (error.response.status !== 401) {
        ApiErrorComp(error.response.status);
      } else {
        setLoginError(true);
      }
    }
  }

  const postData = (data) => {
    const datetimes = stormResponse.data.filter(
      (obj) =>
        ["dateTimePicker", "datePicker"].indexOf(obj.typ) > -1 && obj.format
    );
    const rangePicker = stormResponse.data.filter(
      (obj) => ["rangePicker"].indexOf(obj.typ) > -1
    );

    for (const idx in rangePicker) {
      data = {
        ...data,
        [rangePicker[idx]["_id"]]: [
          moment(data[rangePicker[idx]["_id"]][0]).format(
            rangePicker[idx].format ? rangePicker[idx].format : "YYYY-MM-DD"
          ),
          moment(data[rangePicker[idx]["_id"]][1]).format(
            rangePicker[idx].format ? rangePicker[idx].format : "YYYY-MM-DD"
          ),
        ],
      };
    }

    for (const idx in datetimes) {
      data = {
        ...data,
        [datetimes[idx]["_id"]]: moment(data[datetimes[idx]["_id"]]).format(
          datetimes[idx].format
        ),
      };
    };
    let updatedData = {};
    const objKeys = Object.keys(data);
    objKeys.forEach(x => {
      if (!x.includes('rmrk')) {
        if (!updatedData[x]) {
          updatedData[x] = {
            ans: data[x]
          };
        } else {
          updatedData[x].ans = data[x];
        }
      } else {
        let key = x.split("_")[1];
        if (!updatedData[key]) {
          updatedData[key] = {
            remark: data[x]
          };
        } else {
          updatedData[key].remark = data[x];
        }
      };
    });
    if (stormResponse?.config?.buttons[advanceBtnIndex].method === 'PATCH') {
      liracrypt
        .patch(stormResponse?.config?.buttons[advanceBtnIndex].url, { sessid: docNo, stormAnswerDict: updatedData })
        .then(onResponse)
        .catch(onResponseError);
    };
    if (stormResponse?.config?.buttons[advanceBtnIndex].method === 'POST') {
      liracrypt
        .post(stormResponse?.config?.buttons[advanceBtnIndex].url, { sessid: docNo, stormAnswerDict: updatedData })
        .then(onResponse)
        .catch(onResponseError);
    };

  };

  const onFinishFailed = (e) => {
    
  };
  const onFinish = (data) => {
    postData(data);
  };

  const formStyle = (formConfig) => {
    const style = {
      width: formConfig.formWidth ? formConfig.formWidth : "1000px",
      background: `linear-gradient(to right, ${formConfig.DivBackgroundColor[0]}, ${formConfig.DivBackgroundColor[1]})`,
      align: formConfig.DivAlignment ? formConfig.DivAlignment : "center",
      marginLeft: formConfig.LeftMargin ? formConfig.LeftMargin : "0px",
      paddingLeft: formConfig.InnerLeftPadding
        ? formConfig.InnerLeftPadding
        : "15px",
      paddingRight: formConfig.InnerRightPadding
        ? formConfig.InnerRightPadding
        : "15px",
    };

    if (formConfig["line-color"]) {
      style["borderBottom"] = `1px solid formConfig["line-color"]`;
    }

    return style;
  };


  const auxLines = ({ spec, aux1, aux2, aux3, aux4 }) => (
    <div className="aux-lines">

      {
        spec && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.spec),
            padding: stormResponse?.config?.spec["row-padding"],
          }}>
            <span>{stormResponse?.config?.spec.prefix}</span>
            <span>{spec}</span>
          </p>
        )
      }



      {
        aux1 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux1),
            padding: stormResponse?.config?.aux1["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux1.prefix}</span>
            <span>{aux1}</span>
          </p>
        )
      }
      {
        aux2 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux2),
            padding: stormResponse?.config?.aux2["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux2.prefix}</span>
            <span>{aux2}</span>
          </p>
        )
      }
      {
        aux3 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux3),
            padding: stormResponse?.config?.aux3["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux3.prefix}</span>
            <span>{aux3}</span>
          </p>
        )
      }
      {
        aux4 && (
          <p style={{
            ...getStyleProperties(stormResponse?.config?.aux4),
            padding: stormResponse?.config?.aux4["row-padding"],
          }}>
            <span>{stormResponse?.config?.aux4.prefix}</span>
            <span>{aux4}</span>
          </p>
        )
      }
      
    </div>
    
  );

  const RemarkTextBox = (elem) => {
    if (elem.rmrk) {
      form.setFieldsValue({ [`rmrk_${elem._id}`]: defaultValue });
    }
    return (
    
      <TextBox
        form={form}
        name={`rmrk_${elem._id}`}
        label=""
        // disabled={elem.readOnly ? true : false}
        // required={elem.required ? elem.required : false}
        defaultValue={elem.rmrk ? elem["rmrk"] : null}
        type="input"
        // errorMessage={elem.errorMessage ? elem.errorMessage : "invalid!"}
        placeholder={"Remark"}
      />
    )
  }

  const QusAns = (question, form) => {
    let { spec, aux1, aux2, aux3, aux4, rmrkTxtBox } = question;
    return (
      <>
        <Col
          key={"qus" + question._id + question.seq}
          span={24}
          style={{ padding: "10px 10px" }}
        >
          <p
            className="question"
            style={{
              ...getStyleProperties(stormResponse?.config?.question),
              padding: stormResponse?.config?.question["row-padding"],
            }}
          >
            <span>{question.seq}:</span> {question.param}
          </p>

          {auxLines({ spec, aux1, aux2, aux3, aux4 })}

          <div
            style={{
              ...getStyleProperties(stormResponse?.config["answer "]),
              padding: stormResponse?.config["answer "]["row-padding"],
            }}
          >
             
            <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
              <FormElement elemData={question} form={form} />
              {
                rmrkTxtBox && (
                  RemarkTextBox(question)
                )
              }
            </div>
          </div>
        </Col>
      </>
    );
  };

  const getButton = (button, form) => {
    return (
      <>
        <Col span={24} style={{ padding: "10px 10px" }}>
          <p
            className="question"
            style={{
              ...getStyleProperties(stormResponse?.config?.rows),
              padding: stormResponse?.config?.rows["row-padding"],
            }}
          >
            {/* <span>{question.qno}:</span> {question.qtn} */}
          </p>

          {/* <FormElement elemData={question} form={form} /> */}
        </Col>
      </>
    );
  };

  const getFooter = (footer, footerNotes) => {
    return (
      <Row className="storm-footer">
        <Col
          span={24}
          style={{
            ...getStyleProperties(footer),
            padding: footer["row-padding"],
          }}
        ></Col>
        <Col span={24}>
          <ul style={{ listStyle: "none", paddingLeft: "0px" }}>
            {footerNotes.map((fItem, index) => {
              return (
                <li
                  style={{
                    ...getStyleProperties(fItem),
                    padding: fItem["row-padding"]
                      ? fItem["row-padding"]
                      : "5px",
                  }}
                >
                  {fItem["text"]}
                </li>
              );
            })}
          </ul>
        </Col>
      </Row>
    );
  };

  const getHeader = (title, subtitle, header1, header2, header3, header4,header5, header6, header7, header8) => {
    return (
      <Row
        className="storm-header"
        style={{
          ...getStyleProperties(title),
          padding: title["row-padding"],
        }}
      >
        <Col
          span={24}
          style={{
            ...getStyleProperties(title),
            textAlign: title["align"] ? title["align"] : "left",
            padding: title["row-padding"] ? title["row-padding"] : 0,
          }}
        >
          <span>{title["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(subtitle),
            padding: subtitle["row-padding"] ? subtitle["row-padding"] : 0,
            textAlign: subtitle["align"] ? subtitle["align"] : "left",
          }}
        >
          <span>{subtitle["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(header1),
            padding: header1["row-padding"] ? header1["row-padding"] : 0,
            textAlign: header1["align"] ? header1["align"] : "left",
          }}
        >
          <span>{header1["label"]}</span>
        </Col>


        <Col
          span={24}
          style={{
            ...getStyleProperties(header2),
            padding: header2["row-padding"] ? header2["row-padding"] : 0,
            textAlign: header2["align"] ? header2["align"] : "left",
          }}
        >
          <span>{header2["label"]}</span>
        </Col>

        <Col
          span={24}
          style={{
            ...getStyleProperties(header3),
            padding: header3["row-padding"] ? header3["row-padding"] : 0,
            textAlign: header3["align"] ? header3["align"] : "left",
          }}
        >
          <span>{header3["label"]}</span>
        </Col>

        <Col
          span={24}
          style={{
            ...getStyleProperties(header4),
            padding: header4["row-padding"] ? header4["row-padding"] : 0,
            textAlign: header4["align"] ? header4["align"] : "left",
          }}
        >
          <span>{header4["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(header5),
            padding: header5["row-padding"] ? header5["row-padding"] : 0,
            textAlign: header5["align"] ? header5["align"] : "left",
          }}
        >
          <span>{header5["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(header6),
            padding: header6["row-padding"] ? header6["row-padding"] : 0,
            textAlign: header6["align"] ? header6["align"] : "left",
          }}
        >
          <span>{header6["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(header7),
            padding: header7["row-padding"] ? header7["row-padding"] : 0,
            textAlign: header7["align"] ? header7["align"] : "left",
          }}
        >
          <span>{header7["label"]}</span>
        </Col>
        <Col
          span={24}
          style={{
            ...getStyleProperties(header8),
            padding: header8["row-padding"] ? header8["row-padding"] : 0,
            textAlign: header8["align"] ? header8["align"] : "left",
          }}
        >
          <span>{header8["label"]}</span>
        </Col>

      </Row>
    );
  };


  const EModal = (
    <HModal
      isModalVisible={isHModalVisible}
      setIsModalVisible={setIsHModalVisible}
      modalMethod={"edit"}
      action={action}
      modalData={null}
      extraData={selectedRowData}
      preventSubmitBtnClick={true}
    />
  )

  return (
    <React.Fragment>
      {stormResponse && stormResponse.config && (
        <Row className="storm-custom">
          <Col span={24}>
            {getHeader(

              stormResponse.config?.formTitle,
              stormResponse.config?.formSubTitle,
              stormResponse.config?.header1,
              stormResponse.config?.header2,
              stormResponse.config?.header3,
              stormResponse.config?.header4,
              stormResponse.config?.header5,
              stormResponse.config?.header6,
              stormResponse.config?.header7,
              stormResponse.config?.header8
            )}
          </Col>
          <Col span={24}>
            <div style={{ borderTop: "3px solid #ecf0f1 ", marginLeft: 0, marginRight: 0 }}></div>

            <div style={formStyle(stormResponse.config.formConfig)}>
              <Form
                name="ReportForm"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                layout="horizontal"
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                size="large"
              >
                {stormResponse.data.map((question) => QusAns(question, form))}
                <Col span={12} style={{ padding: "0px 0px" }}>
                  {stormResponse.config.buttons.map((btn, index) => (
                    <AdvanceButton
                      btnIndex={index}
                      setAdvanceBtnIndex={setAdvanceBtnIndex}
                      form={form}
                      label={btn.label}
                      type={btn.type}
                      disabled={btn.disabled}
                      confirmationPopUp={btn.confirmationPopUp}
                    />
                  ))}
                </Col>
              </Form>
            </div>
          </Col>
          <Col span={24}>
            {getFooter(
              stormResponse.config?.footer,
              stormResponse.config?.footerNotes
            )}
          </Col>
        </Row>
      )}
      {EModal}
    </React.Fragment>
  );
};
export default OpObservShStorm;